import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import SoftButton from "StyleFeatures/SoftButton";
import { Link } from "react-router-dom";
import { Edit } from "@mui/icons-material";
import API from "api/endpoints";
import columns from "../../Pages/AdministratorDashboard/Hiring/JobPosting/HiringTableColumns";

import {
  getJobPostings,
  addJobPosting,
  updateJobPosting,
} from "Services/AdminServices/HiringService";
import { resetJobPostingForm } from "../../Pages/AdministratorDashboard/Hiring/JobPosting/resetFormFields";
import axiosInstance from "api/axiosInstance";

function useHiring() {
  const [form] = Form.useForm();
  const [jobPostings, setJobPostings] = useState([]);
  const [isCompensationEnabled, setIsCompensationEnabled] = useState(false);
  const [jobDescription, setJobDescription] = useState(
    `We provide equal employment opportunities to all employees and applicants for employment and prohibits discrimination and harassment of any type. 
    Datagonomix considers applicants for employment without regard to race, color, religion, age, sex, national origin, disability status, genetic information, 
    protected veteran status, sexual orientation, gender, gender identity or expression, or any other characteristic protected by federal, state, provincial 
    or local laws.`
  );
  const [showForm, setShowForm] = useState(false);
  const [editingJobId, setEditingJobId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addloading, setAddLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [ jobTitles, setJobTitles] = useState([]);
  const [ selectedDepartmentId, setSelectedDepartmentId ] =  useState(null);
  const [ selectedJobTitle , setSelectedJobTitle] = useState(null);
  

  useEffect(() => {
    fetchJobPostings();
  
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await axiosInstance.get(API.department.getList);
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching Department List ");
      throw error;
    }
  };
  
  const  handleDepartmentChange = async(value) => {
      const deptId = value!= null ? Number(value) : null;
      setSelectedDepartmentId(deptId)
      const response = await axiosInstance.get(API.jobTitle.getListByLookup(deptId));
      setJobTitles(response.data);
  }

  const fetchJobPostings = async () => {
    setLoading(true);
    try {
      const response = await getJobPostings();
      if (response && response.postingDetail && response.postingDetail.length > 0) {
        const updatedRows = response.postingDetail.map((info) => {
          const formattedCreatedOn = info.createdOn
            ? new Date(info.createdOn).toLocaleDateString()
            : "N/A";
          const dept = departments.find((d) => d.id === info.id);

          return {
            ...info,
            key: info.id.toString(),
            id: info.id,
            PositionName: info.jobTitle,
            departmentId: info.departmentId,
            departmentName: dept ? dept.name : info.departmentName,
            createdOn: formattedCreatedOn,
            skills: Array.isArray(info.skills) ? info.skills.join("  ") : "N/A",
            isBudgetApproved: info.isBudgetApproved,
            managerId: info.managerId,
            employementType: info.employementType,
            maximumExperience: info.maximumExperience,
            compensation: info.compensation,
            jobLocationType: info.jobLocationType,
            jobType: info.jobType,
            jobDescription: info.jobDescription,
            jobInternalCode: info.jobInternalCode,
            skills: Array.isArray(info.skills) ? info.skills : [],

ViewCandidate: (
  <SoftButton className="btn-back" size="small">
    <Link 
      to={`/viewcandidate/${info.id}`} 
      style={{ 
        color: "inherit", 
        textDecoration: "none",
        display: "block",
        width: "100%" 
      }}
    >
      View Candidate
    </Link>
  </SoftButton>
),
            Action: (
              <span style={{ display: "flex", alignItems: "center" }}>
                <Edit style={{ cursor: "pointer" }} onClick={() => handleEdit(info)} />
              </span>
            ),
          };
        });
        setJobPostings(updatedRows);
      }
    } catch (error) {
      console.error("Error fetching job postings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleJobTitleChange = async(value) => {
     const id = value != null ? Number(value): null
     setSelectedJobTitle(id)
    }

 

  const handleEdit = async (info) => {
  const deptId = info.departmentId;

  // 🔥 fetch job titles first
  const response = await axiosInstance.get(API.jobTitle.getListByLookup(deptId));
  setJobTitles(response.data);

  form.setFieldsValue({
    jobTitleId: info.jobTitleId,
    departmentId: String(info.departmentId),
    isBudgetApproved: info.isBudgetApproved ? "Yes" : "No",
    employementType: info.employementType,
    maximumExperience: info.maximumExperience,
    compensation: info.compensation,
    jobLocationType: info.jobLocationType,
    jobType: info.jobType,
    jobInternalCode: info.jobInternalCode,
    skills: Array.isArray(info.skills) ? info.skills : [],
  });

  setEditingJobId(info.jobPostingId || info.id);
  setJobDescription(info.jobDescription);
  setShowForm(true);
};

  const handleAddJob = () => {
    form.resetFields();
    setEditingJobId(null);
    setShowForm(true);
  };

  const handleBackToList = () => {
    resetJobPostingForm(form);
    setEditingJobId(null);
    setShowForm(false);
  };

 const onFinish = async (values) => {
  const finalValues = {
    jobPostingId: editingJobId || 0, // 🔥 REQUIRED FIX
    jobTitleId: values.jobTitleId || 0,
    isBudgetApproved: values.isBudgetApproved === "Yes",
    status: values.status || 0,
    departmentId: parseInt(values.departmentId) || 0,
    employementType: values.employementType || "",
    maximumExperience: values.maximumExperience || "",
    compensation: isCompensationEnabled ? values.compensation : "0",
    jobLocationType: values.jobLocationType || "",
    jobType: values.jobType || "",
    jobInternalCode: values.jobInternalCode || "",
    jobDescription: jobDescription || "",
    skills: values.skills || [],
  };

  try {
    setAddLoading(true);
    if (editingJobId) {
      await updateJobPosting(finalValues);
    } else {
      await addJobPosting(finalValues);
    }
      message.success("Job posting submitted successfully.");
      setShowForm(false);
      fetchJobPostings();
      resetJobPostingForm(form);
    } catch (error) {
      console.error(" Error submitting:", error.response?.data || error.message);
      const errorMessages = error.response?.data?.errors
        ? Object.values(error.response.data.errors).flat().join(", ")
        : "Failed to submit the job posting. Please try again.";
      message.error(errorMessages);
    } finally {
      setAddLoading(false);
    }
  };

  // Define columns for the table

  const handleBudgetApprovalChange = (value) => {
    setIsCompensationEnabled(value === "Yes");
    if (value === "No") {
      form.setFieldsValue({ compensation: "$0" });
    } else {
      form.setFieldsValue({ compensation: "" });
    }
  };

  return {
    handleBackToList,
    handleAddJob,
    form,
    jobPostings,
    showForm,
    loading,
    addloading,
    onFinish,
    columns,
    setShowForm,
    jobDescription,
    setJobDescription,
    editingJobId,
    isCompensationEnabled,
    handleBudgetApprovalChange,
    departments,
    jobTitles,
    handleDepartmentChange,
    selectedDepartmentId,
    selectedJobTitle,
    handleJobTitleChange
  };
}

export default useHiring;
